import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ProductoService{
    constructor(){}

    async consultarClausulados(codigoRamo: number){
        let url=new URL(`${environment.backendUrl}/api/clausulado`);
        let parameters={
            cod_ramo: codigoRamo==null?0:codigoRamo
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object=await (await fetch(url.toString(), {method: 'GET'})).json();
        return object;
    }

    async consultarObjetosContrato(codigoRamoComercial: number){ 
        let ramoComercial=codigoRamoComercial==null?0:codigoRamoComercial;
        let listaRamos=await this.consultarRamosTecnicos(ramoComercial);
        let url=new URL(`${environment.backendUrl}/api/objetoSeguro`);
        let parameters={
            cod_ramo: ramoComercial,
            lista_ramos: listaRamos
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object=await (await fetch(url.toString(), {method: 'GET'})).json();
        return object;
    }

    /**
     * 
     * @param codigoRamoComercial 
     * @param codigoSucursal 
     * @param codigoUsuario 
     * @param objetoSeguro [ramoTecnico, objetoContrato]
     */
    async consultarAmparos(codigoRamoComercial: number, codigoSucursal: number, codigoUsuario: string, objetoSeguro: number){
        let ramoComercial=codigoRamoComercial==null?0:codigoRamoComercial;
        let ramoTecnicoObjetoSeguro=`${(await this.consultarRamosTecnicos(ramoComercial))},${objetoSeguro}`;
        let url=new URL(`${environment.backendUrl}/api/amparo`);
        let parameters={
            cod_ramo: codigoRamoComercial,
            cod_suc: codigoSucursal,
            cod_usuario: codigoUsuario,
            objeto_seguro: ramoTecnicoObjetoSeguro
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object=await (await fetch(url.toString(), {method: 'GET'})).json();
        return object;
    }

    async consultarRamosTecnicos(codigoRamoComercial){
        let url=new URL(`${environment.backendUrl}/api/ramoTecnico`);
        let parameters={
            cod_ramo: codigoRamoComercial==null?0:codigoRamoComercial,
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let object=await (await fetch(url.toString(), {method: 'GET'})).json();

        let listaRamos="";
        object.forEach((ramoTecnico, index)=>{
            listaRamos+=ramoTecnico.codigo_ramo_tecnico;
            if(index!=object.length-1){
                listaRamos+=",";
            }
        });
        return listaRamos;
    }

    async consultarGirosNegocio(codigoRamo: number){
        let url=new URL(`${environment.backendUrl}/api/giroNegocio`);
        let parameters={
            codRamo: codigoRamo==null?0:codigoRamo,
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        return await (await fetch(url.toString(), {method: 'GET'})).json();
    }

    async consultarFechaEmision(codigoAgencia: number){
        let url=new URL(`${environment.backendUrl}/api/emision`);
        let parameters={
            cod_sucursal: codigoAgencia,
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        let fechaEmision=await (await fetch(url.toString(), {method: 'GET'})).json();
        return new Date(fechaEmision);
    }

    async consultarValorPrimaMinima(codigoRamo: number, codigoAgencia: number){
        let url=new URL(`${environment.backendUrl}/api/prima`);
        let parameters={
            cod_sucursal: codigoAgencia==null?0:codigoAgencia,
            cod_ramo: codigoRamo==null?0:codigoRamo
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        return await (await fetch(url.toString(), {method: 'GET'})).json();
    }

    async consultarParametrosVigencia(codigoRamo: number){
        let url=new URL(`${environment.backendUrl}/api/vigencia`);
        let parameters={
            cod_ramo: codigoRamo==null?0:codigoRamo
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));

        return await (await fetch(url.toString(), {method: 'GET'})).json();
    }

    async consultarTasa(){
        let url=`${environment.backendUrl}/api/tasa`;
        return await (await fetch(url, {method: 'GET'})).json();
    }

}